import { TerminalProfileDtoToEntity } from "src/app/features/TerminalProfile/services/mappers/TerminalProfileDtoToEntity";
import type { TerminalProfileDto } from "src/app/features/TerminalProfile/types/TerminalProfileDto";
import type { TerminalProfileEntity } from "src/app/features/TerminalProfile/types/TerminalProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const TerminalProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<TerminalProfileDto>>,
): ResourcePageEntity<TerminalProfileEntity> => {
    return {
        list: input.list ? input.list.map(TerminalProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
